import { useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { hasBrowserSession, isIdleExpired, markSessionExpiredNotice, touchSessionActivity } from '../authSession';
import { clearAuthSession } from '../services/serviceconfig';
import { performLogout } from '../services/LoginServices';

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'];

export default function SessionTimeoutMonitor() {
  const [cookies] = useCookies(['myToken']);
  const navigate = useNavigate();
  const cookiesRef = useRef(cookies);

  useEffect(() => {
    cookiesRef.current = cookies;
  }, [cookies]);

  useEffect(() => {
    const onActivity = () => touchSessionActivity();
    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });

    const intervalId = window.setInterval(() => {
      const currentCookies = cookiesRef.current;
      if (!currentCookies?.myToken || !hasBrowserSession()) {
        return;
      }
      if (isIdleExpired()) {
        markSessionExpiredNotice();
        performLogout(currentCookies).catch(() => {});
        clearAuthSession();
        navigate('/', { replace: true });
      }
    }, 60 * 1000);

    return () => {
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
      window.clearInterval(intervalId);
    };
  }, [navigate]);

  return null;
}
